// Homepage behaviour (issue 30): shows the customer's menu in every [data-cck-region-panel]
// (the menu, broths and treats), the fee for their band, "I can't reach you yet" when their
// pincode isn't served, and the menu's protein filters. The region comes from the pincode gate
// (cck-region.js, issue 28): its latest outcome on window.CCK_OUTCOME, then `cck:region` events.
// Collection pages (issue 107) use the same protein filters, and a sort order that applies at once.

const money = (/** @type {number} */ n) => `₹${n.toLocaleString("en-IN")}`;

function showRegion(/** @type {any} */ outcome) {
  const region =
    outcome?.region === "national" ? "national" : outcome?.region === "none" ? "none" : "ncr";
  for (const el of document.querySelectorAll("[data-cck-region-panel]")) {
    if (!(el instanceof HTMLElement)) continue;
    const regions = (el.dataset.cckRegionPanel ?? "").split(" ");
    el.hidden = !regions.includes(region);
  }
  // The menu's own "I can't reach you yet" card; the header shows its own too.
  const section = document.querySelector("[data-cck-menu-section]");
  const box = section?.querySelector("[data-cck-not-served]");
  if (box instanceof HTMLElement) box.hidden = region !== "none";
  if (outcome?.region === "ncr" && outcome.fee) {
    for (const fee of document.querySelectorAll("[data-cck-fee-text]")) {
      fee.textContent = `${money(outcome.fee)} delivery under ${money(outcome.freeFrom)} (band ${outcome.band}), free above`;
    }
  }
}

function setUpFilters() {
  for (const group of document.querySelectorAll(".cck-filters")) {
    const buttons = [...group.querySelectorAll("[data-cck-filter]")];
    for (const b of buttons) {
      b.addEventListener("click", () => {
        const f = b.getAttribute("data-cck-filter") ?? "all";
        for (const x of buttons) x.setAttribute("aria-pressed", String(x === b));
        for (const card of document.querySelectorAll(".cck-meal-card")) {
          if (!(card instanceof HTMLElement)) continue;
          const proteins = (card.dataset.cckProteins ?? "").split(" ");
          card.hidden = f !== "all" && !proteins.includes(f);
        }
      });
    }
  }
}

document.addEventListener("cck:region", (e) =>
  showRegion(/** @type {CustomEvent} */ (e).detail?.outcome),
);
showRegion(/** @type {any} */ (window).CCK_OUTCOME);
setUpFilters();

// Collection pages (issue 107): a new sort order loads straight away.
for (const form of document.querySelectorAll("[data-cck-sort]")) {
  form.querySelector("select")?.addEventListener("change", () => {
    if (form instanceof HTMLFormElement) form.requestSubmit();
  });
}
